import { get } from '@/api';
import { clone } from '@/utils/utils';
// import config from "../../global/config"
const state = {
	hos_msg: {
		hos_name: '减重患者队列管理系统',
		sys_picture: '/logo.png',
		not_get: true,
	},
	userData: {},
	sys_version: 'v1.0.0.01',
	now_auth: [],

	// 公共编辑form存储
	comForm: null,
	comTitle: '',
	comType: '',
	// 角色
	title: '',
	look: true,
	roleForm: {},
	authority: [],

	view_is_locking: false, // 页面正在锁定

	sreenType: 'landscape',
	sreenTypeChange: true,

	all_table_list: [],

	app_env: '',
	has_config: false,

	export_type: [],
	ill_types: [],
	dtype_names: {
		1: '检查报告',
		2: '检验报告',
		3: '门诊',
		4: '住院',

		5: '检查影像',
		6: '其他',
		7: '体检报告',
	},
	log_action: [],

	all_organs: [],
	organization_list: [],
	organization_list_all: [],

	surgeryOptions: [],
	stageOptions: [],
	medicationTypeOptions: [],
	symptomTrendOptions: [],
	symptomPartOptions: [],
	postureOptions: [],
	edit_ques: false,

	match_field_list: [
		{ name: '姓名', value: 'name' },
		{ name: '性别', value: 'sex_str' },
		{ name: '年龄', value: 'age' },
		{ name: '身高', value: 'height' },
		{ name: '体重', value: 'weight' },
		{ name: '出生日期', value: 'birth_date' },
		{ name: 'BMI', value: 'bmi' },
		{ name: '颈围', value: 'neck_cir' },
		{ name: '腰围', value: 'waist_cir' },
		{ name: '臀围', value: 'hip_cir' },
		{ name: '登记号', value: 'clinic_no' }, // 门诊号
	],

	// 问卷答案
	questionResults: [],
	ques_base_record_id: {}, // 问卷基本信息id
	// 课题列表
	issueList: [],
	// 当前用户角色的课题限制范围
	role_project_ids: [],
};

const mutations = {
	setEditQues(state, data) {
		state.edit_ques = data;
	},
	setDictionSelect(state, payload) {
		// console.log(payload, 'dict-39');
		state.surgeryOptions = [];
		state.stageOptions = [];
		state.medicationTypeOptions = [];
		state.symptomTrendOptions = [];
		state.symptomPartOptions = [];
		state.postureOptions = [];
		payload.forEach((e) => {
			if (e.field_type === 'surgery') {
				// state.surgeryOptions = e.detail;
				e.detail.forEach((v) => {
					let item = {
						...v,
						organization_id: e.organization_id || '',
					};
					state.surgeryOptions.push(item);
				});
			}
			if (e.field_type === 'stage') {
				// state.stageOptions = e.detail;
				e.detail.forEach((v) => {
					let item = {
						...v,
						organization_id: e.organization_id || '',
					};
					state.stageOptions.push(item);
				});
			}
			if (e.field_type === 'medication_type') {
				e.detail.forEach((v) => {
					let item = {
						label: v.name,
						value: parseInt(v.value),
						organization_id: e.organization_id || '',
					};
					state.medicationTypeOptions.push(item);
				});
			}
			if (e.field_type === 'skin_symptom') {
				e.detail.forEach((v) => {
					let item = {
						label: v.name,
						value: parseInt(v.value),
						organization_id: e.organization_id || '',
					};
					state.symptomTrendOptions.push(item);
				});
			}
			if (e.field_type === 'symptom_part') {
				e.detail.forEach((v) => {
					let item = {
						label: v.name,
						value: parseInt(v.value),
						organization_id: e.organization_id || '',
					};
					state.symptomPartOptions.push(item);
				});
			}
			if (e.field_type === 'posture') {
				e.detail.forEach((v) => {
					let item = {
						label: v.name,
						value: v.name,
						organization_id: e.organization_id || '',
					};
					state.postureOptions.push(item);
				});
			}
		});
	},
	setUserData(state, data) {
		state.userData = JSON.parse(data);
	},
	setOrgList(state, data) {
		if (data) {
			let userStr = sessionStorage.getItem('user');
			if (!userStr) return;
			let user_id = JSON.parse(userStr).bind_org_id;
			if (user_id && user_id.length > 0) {
				state.organization_list = JSON.parse(JSON.stringify(data)).filter((v) =>
					user_id.includes(v.organization_id),
				);
			} else {
				state.organization_list = [];
			}
			state.organization_list_all = JSON.parse(JSON.stringify(data));
		}
	},
	setNowAuthData(state, payload) {
		state.now_auth = payload;
	},
	setHosMsg(state, payload) {
		state.hos_msg = payload;
		document.title = payload.hos_name;
	},
	setViewLock(state, payload) {
		state.view_is_locking = payload;
	},

	// 统计 search 机构、分支数据
	setOrgans(state, payload) {
		state.all_organs = payload;
	},

	// 公共编辑form
	setComFormData(state, payload) {
		state.comForm = payload.form;
		state.comTitle = payload.title;
		state.comType = payload.type;
	},
	// 角色
	setRoleTitle(state, payload) {
		state.roleTitle = payload.title;
		state.look = payload.look;
	},
	setRowData(state, payload) {
		state.roleForm = payload.form;
		state.authority = payload.authority;
	},
	// 保存横竖屏数据  vertical
	setSreenType(state, payload) {
		state.sreenType = payload;
		state.sreenTypeChange = !state.sreenTypeChange;
	},

	// 保存table数据，进行编辑切换 report
	setAllTableList(state, payload) {
		if (payload === 'clear') {
			state.all_table_list = [];
		} else {
			state.all_table_list = payload;
		}
	},

	set_all_config(state, data) {
		state.app_env = data.app_env;
		state.export_type = data.export_type;

		state.has_config = true;
	},

	// 问卷答案 废弃
	setOldResult(state, payload) {
		state.questionResults = payload ? clone(payload) : {};
	},
	set_ques_base_data(state, payload) {
		state.ques_base_record_id = payload;
	},
	// 课题列表
	setIssueList(state, payload) {
		state.issueList = payload || [];
	},
	setRoleProjectIds(state, payload) {
		state.role_project_ids = payload || [];
	},
};

const actions = {
	getAuthorityData({ commit, dispatch }) {
		return new Promise((resolve, reject) => {
			get('/user_authority').then((res) => {
				if (!res.authorities) {
					resolve(res);
					return;
				}
				commit('setNowAuthData', res.authorities);
				resolve(res);
			});
		});
	},
	getComConfig({ commit, dispatch, state }) {
		// 获取公共配置
		return new Promise((resolve, reject) => {
			resolve();
			// if (state.has_config) {
			//     resolve('has_config');
			//     return
			// }
			// get('/conf').then(res => {
			//     commit("set_all_config", res.data);
			//     resolve(res);
			// })
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};